import { Expose, Type } from 'class-transformer';
import { GetLocationSupportDto } from './get-location-support.dto';
import { GetBuildingAddressDto } from './get-building-address.dto';
import { GetLocationFloorTreeResponseDto } from './get-location-floor-tree-response.dto';
import { GetLocationSpaceTreeResponseDto } from './get-location-space-tree-response.dto';
import { GetLocationBuildingTreeResponseDto } from './get-location-building-tree-response.dto';
import { GetLocationResourceTreeResponseDto } from './get-location-resource-tree-response.dto';
import {GetLocationExtraInformationDto} from "../../../room/dto/response/get-location-extra-information.dto";

export class GetLocationTreeResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'address_id' })
  addressId: number;
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'support' })
  @Type(() => GetLocationSupportDto)
  support: GetLocationSupportDto;
  @Expose({ name: 'extra_information' })
  @Type(() => GetLocationExtraInformationDto)
  extraInformation: GetLocationExtraInformationDto;
  @Expose({ name: 'address' })
  @Type(() => GetBuildingAddressDto)
  address: GetBuildingAddressDto;
  @Expose({ name: 'buildings' })
  @Type(() => GetLocationBuildingTreeResponseDto)
  buildings: GetLocationBuildingTreeResponseDto[];
  @Expose({ name: 'floors' })
  @Type(() => GetLocationFloorTreeResponseDto)
  floors: GetLocationFloorTreeResponseDto[];
  @Expose({ name: 'spaces' })
  @Type(() => GetLocationSpaceTreeResponseDto)
  spaces: GetLocationSpaceTreeResponseDto[];
  @Expose({ name: 'resources' })
  @Type(() => GetLocationResourceTreeResponseDto)
  resources: GetLocationResourceTreeResponseDto[];
}
